import { Grid } from '../types/grid';
import { computed } from '@angular/core';
import { DataSource } from '@softapps/core';
import { formatter } from '@softline/ui-core';
import { GridRef } from '../types/refs';

export function grid<TRow extends object>(
  dataSource: DataSource<TRow>,
  factory: (ref: GridRef<TRow>) => void): Grid<TRow> {
  const f = formatter();
  const grid = computed(() => {
    const ref: GridRef<TRow> = new GridRef<TRow>(dataSource, f);
    factory(ref);
    return {
      columns: ref.columns,
      detail: ref.detail,
      detailOptions: ref.detailOptions,
      insertRow: ref.insertRow,
      editRow: ref.editRow,
      deleteRow: ref.deleteRow,
      validate: ref.validate,
      tree: ref.tree,
      selectable: ref.selectable,
      getRowClass: ref.getRowClass,
      options: ref.options,
      };
  })();
  const columns = computed(() => grid.columns);
  const detail = grid.detail;

  return {
    dataSource,
    columns,
    detail,
    detailOptions: grid.detailOptions,
    options: grid.options ?? undefined,
    insertRow: grid.insertRow,
    editRow: grid.editRow,
    deleteRow: grid.deleteRow,
    validate: grid.validate,
    tree: grid.tree,
    selectable: grid.selectable,
    getRowClass: grid.getRowClass ?? undefined,
  };
}
